import request from './request.js';

/**
 *
 * @param {*} cursor
 * @param {*} query
 */
function getAll(cursor, query) {
    const encodedQuery = query ? encodeURIComponent(query) : '';
    const endpoint = `/user?cursor=${ cursor }&query=${ encodedQuery }`;
    const options = {
        endpoint,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 */
function get(userID) {
    const options = {
        endpoint: `/user/${ userID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param cert
 * @param claimID
 * @returns {Promise<unknown>}
 */
function getClaimCertMeta(cert, claimID) {
    const options = {
        endpoint: `/user/claimMeta/${ cert }/${ claimID || null }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param cert
 * @returns {Promise<unknown>}
 */
function getUserByCert(cert) {
    const options = {
        endpoint: `/user/cert/${ cert }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} filters
 * @param {*} sort
 * @param {*} cursor
 * @returns
 */
function getClaims(userID, filters, sort, cursor = 0) {
    const options = {
        endpoint: `/user/${ userID }/claims?cursor=${ cursor }`,
        method: 'POST',
        body: {
            filters,
            sort
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} filters
 * @param {*} sort
 * @returns
 */
function getHSAClaims(userID, filters, sort) {
    const options = {
        endpoint: `/user/${ userID }/hsaClaims`,
        method: 'POST',
        body: {
            filters,
            sort
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} filters
 * @param {*} sort
 * @returns
 */
function getLSAClaims(userID, filters, sort) {
    const options = {
        endpoint: `/user/${ userID }/lsaClaims`,
        method: 'POST',
        body: {
            filters,
            sort
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} claimID
 */
function getClaim(userID, claimID) {
    const options = {
        endpoint: `/user/${ userID }/claims/${ claimID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} body
 */
function addDependent(userID, body) {
    const options = {
        endpoint: `/user/${ userID }/dependents`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} dependentID
 * @param {*} body
 */
function editDependent(userID, dependentID, body) {
    const options = {
        endpoint: `/user/${ userID }/dependents/${ dependentID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param dependentID
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function removeDependent(userID, dependentID, effectiveDate) {
    const options = {
        endpoint: `/user/${ userID }/dependents/${ dependentID }`,
        method: 'DELETE',
        body: {
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param dependentID
 * @returns {Promise<unknown>}
 */
function getDependentTerminatedBenefits(userID, dependentID) {
    const options = {
        endpoint: `/user/${ userID }/dependents/${ dependentID }/terminateBenefits`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param dependentID
 * @param benefitsToTerminate
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function terminateDependentBenefits(userID, dependentID, benefitsToTerminate, effectiveDate) {
    const options = {
        endpoint: `/user/${ userID }/dependents/${ dependentID }/terminateBenefits`,
        method: 'PUT',
        body: {
            benefits: benefitsToTerminate,
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param dependentID
 * @param benefitsToReinstate
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function reinstateDependentBenefits(userID, dependentID, benefitsToReinstate, effectiveDate) {
    const options = {
        endpoint: `/user/${ userID }/dependents/${ dependentID }/reinstateBenefits`,
        method: 'PUT',
        body: {
            benefits: benefitsToReinstate,
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param body
 * @param currentBeneficiaries
 * @returns {Promise<unknown>}
 */
function addBeneficiary(userID, body, currentBeneficiaries) {
    const options = {
        endpoint: `/user/${ userID }/beneficiaries`,
        method: 'POST',
        body: {
            ...body,
            primary: currentBeneficiaries.primary,
            contingent: currentBeneficiaries.contingent
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} beneficiaryID
 * @param {*} body
 * @param currentBeneficiaries
 */
function editBeneficiary(userID, beneficiaryID, body, currentBeneficiaries) {
    const options = {
        endpoint: `/user/${ userID }/beneficiaries/${ beneficiaryID }`,
        method: 'PUT',
        body: {
            ...body,
            primary: currentBeneficiaries.primary,
            contingent: currentBeneficiaries.contingent
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param beneficiaryID
 * @param currentBeneficiaries
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function removeBeneficiary(userID, beneficiaryID, currentBeneficiaries, effectiveDate) {
    const options = {
        endpoint: `/user/${ userID }/beneficiaries/${ beneficiaryID }`,
        method: 'DELETE',
        body: {
            primary: currentBeneficiaries.primary,
            contingent: currentBeneficiaries.contingent,
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} body
 */
function addTrustee(userID, body) {
    const options = {
        endpoint: `/user/${ userID }/trustee`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} trusteeID
 * @param {*} body
 */
function editTrustee(userID, trusteeID, body) {
    const options = {
        endpoint: `/user/${ userID }/trustee/${ trusteeID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param trusteeID
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function removeTrustee(userID, trusteeID, effectiveDate) {
    const options = {
        endpoint: `/user/${ userID }/trustee/${ trusteeID }`,
        method: 'DELETE',
        body: {
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param expectedLeaveReturnDate
 * @returns {Promise<unknown>}
 */
function changeStatusReturnDate(userID, expectedLeaveReturnDate) {
    const options = {
        endpoint: `/user/${ userID }/statusReturnDate`,
        method: 'PUT',
        body: {
            expectedLeaveReturnDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param body
 * @param isProfile
 * @returns {Promise<unknown>}
 */
function editUser(userID, body, isProfile = false) {
    const options = {
        endpoint: isProfile ? `/user/profile/${ userID }` : `/user/${ userID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param accountID
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function terminateUser(userID, accountID, effectiveDate) {
    const endpoint = `/user/${ userID }/${ accountID }`;
    const options = {
        method: 'DELETE',
        endpoint,
        body: {
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<any>}
 */
function sendForgotPassword(body) {
    const options = {
        endpoint: '/user/sendForgotPassword',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param parentID
 * @param body
 * @returns {Promise<any>}
 */
function sendDependentForgotPassword(parentID, body) {
    const options = {
        endpoint: `/user/${ parentID }/dependents/sendForgotPassword`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @returns {Promise<any>}
 */
function sendMagicLink(userID) {
    const options = {
        endpoint: `/user/${ userID }/sendMagicLink`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param password
 * @returns {Promise<any>}
 */
function changePassword(password) {
    const options = {
        endpoint: '/user/password',
        method: 'PUT',
        body: {
            password
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param note
 * @param claimID
 */
function addMemberNote(userID, note, claimID) {
    const body = {
        body: note
    };

    if (claimID) {
        body.claimID = claimID;
    }

    const options = {
        endpoint: `/user/${ userID }/note`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param claimID
 * @param dateRange
 * @returns {Promise<unknown>}
 */
function getMemberNotes(userID, claimID, dateRange) {
    const body = {};

    if (claimID) {
        body.claimID = claimID;
    }

    if (dateRange) {
        body.dateRange = dateRange;
    }

    const options = {
        endpoint: `/user/${ userID }/notes`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param invoiceNum
 * @returns {Promise<unknown>}
 */
function getInvoice(userID, invoiceNum) {
    const options = {
        endpoint: `/user/${ userID }/invoices/${ invoiceNum }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param invoiceNum
 * @returns {Promise<unknown>}
 */
function applyInvoiceCarryForward(userID, invoiceNum) {
    const options = {
        endpoint: `/user/${ userID }/invoices/${ invoiceNum }/applyCarryForward`,
        method: 'POST',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param invoiceNum
 * @returns {Promise<unknown>}
 */
function resetInvoiceToPending(userID, invoiceNum) {
    const options = {
        endpoint: `/user/${ userID }/invoices/${ invoiceNum }/resetToPending`,
        method: 'POST',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} userID 
 * @param {*} benefit 
 * @param {*} effectiveDate 
 * @param {*} action 
 */
function updateBenefitStatus(userID, benefit, effectiveDate, action) {
    const body = {
        effectiveDate: effectiveDate,
        action: action
    };

    const options = {
        endpoint: `/user/${ userID }/benefits/${ benefit }`,
        method: 'PATCH',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} userID 
 * @param {*} benefit 
 * @param {*} effectiveDate 
 * @param {*} action 
 */
function updateBenefitPremium(userID, benefit, effectiveDate, action) {
    const body = {
        effectiveDate: effectiveDate,
        action: action
    };

    const options = {
        endpoint: `/user/${ userID }/benefits/${ benefit }/premium`,
        method: 'PATCH',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} userID 
 * @param {*} effectiveDate 
 * @param {*} action 
 */
function updateAllBenefitPremiums(userID, effectiveDate, action) {
    const body = {
        effectiveDate: effectiveDate,
        action: action
    };

    const options = {
        endpoint: `/user/${ userID }/benefits/premium`,
        method: 'PATCH',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} userID 
 * @param {*} benefit 
 * @param {*} effectiveDate 
 */
function getUserCoverageHistory (userID, coverageHistoryID) {
    const options = {
        endpoint: `/user/${ userID }/coverageHistory/${ coverageHistoryID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} userID 
 * @param {*} benefit 
 * @param {*} effectiveDate 
 */
function getDependentsAtCoverageEndDate (userID, coverageEndDate) {
    const options = {
        endpoint: `/user/${ userID }/dependents/${ coverageEndDate }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param productID
 * @param body
 * @returns {Promise<unknown>}
 */
function getMarketplaceProductRate(productID, body) {
    const options = {
        endpoint: `/user/marketplace/products/${ productID }/rate`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Member Spending Accounts
 * @param {*} userID 
 * @param {*} balanceData 
 * @returns 
 */
function setAllotmentAndBalance(userID, body) {
    const options = {
        endpoint: `/user/${ userID }/allotmentAndBalance`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<any>}
 */
function getMarketplaceProduct(userID, productID) {
    const options = {
        endpoint: `/user/${ userID }/marketplace/products/${ productID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param productID
 * @param failedKnockOutQuestions
 * @returns {Promise<unknown>}
 */
function blockMarketplaceProductCoverage(userID, productID, failedKnockOutQuestions) {
    const options = {
        endpoint: `/user/${ userID }/marketplace/products/block/${ productID }`,
        method: 'POST',
        body: {
            failedKnockOutQuestions
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param body
 * @returns {Promise<unknown>}
 */
function purchaseMarketplaceProduct(userID, body) {
    const options = {
        endpoint: `/user/${ userID }/marketplace/products/purchase`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param productID
 * @param signage
 * @returns {Promise<unknown>}
 */
function terminateMarketplaceProduct(userID, productID, signage) {
    const options = {
        endpoint: `/user/${ userID }/marketplace/products/terminate/${ productID }`,
        method: 'DELETE',
        body: {
            signage
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/** 
 * Member Spending Accounts
 * @param {*} userID 
 */
function triggerPooledAllotment(userID) {
    const options = {
        endpoint: `/user/${ userID }/pooledAllotment`,
        method: 'PUT',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Set member claimsBlocked status
 * @param {string} userID
 * @param {boolean} claimsBlocked
 */
function setClaimsBlockedStatus(userID, claimsBlocked) {
    const options = {
        endpoint: `/user/${ userID }/claims/block`,
        method: 'POST',
        body: { claimsBlocked }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    getAll,
    get,
    getClaims,
    getHSAClaims,
    getLSAClaims,
    getClaim,
    addDependent,
    editDependent,
    removeDependent,
    addBeneficiary,
    editBeneficiary,
    removeBeneficiary,
    addTrustee,
    editTrustee,
    removeTrustee,
    editUser,
    terminateUser,
    sendForgotPassword,
    sendDependentForgotPassword,
    sendMagicLink,
    changePassword,
    addMemberNote,
    getMemberNotes,
    changeStatusReturnDate,
    getClaimCertMeta,
    getUserByCert,
    getInvoice,
    applyInvoiceCarryForward,
    resetInvoiceToPending,
    getDependentTerminatedBenefits,
    terminateDependentBenefits,
    reinstateDependentBenefits,
    updateBenefitStatus,
    updateBenefitPremium,
    updateAllBenefitPremiums,
    getUserCoverageHistory,
    getDependentsAtCoverageEndDate,
    getMarketplaceProductRate,
    getMarketplaceProduct,
    purchaseMarketplaceProduct,
    terminateMarketplaceProduct,
    setAllotmentAndBalance,
    triggerPooledAllotment,
    blockMarketplaceProductCoverage,
    setClaimsBlockedStatus
};